export const MOBILE_MAX = 767;
export const TABLET_MIN = 768;
export const TABLET_MAX = 991;
export const DESKTOP_MIN = 992;
export const DESKTOP_MAX = 1999;
export const LG_DESKTOP_MIN = 1200;

export function isMobile() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
}

export function isTablet() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px) and (max-width: ${TABLET_MAX}px)`).matches;
}

export function isDesktop() {
  return window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches;
}

export function isLargeDesktop() {
  return window.matchMedia(`(min-width: ${LG_DESKTOP_MIN}px)`).matches;
}

export function notMobile() {
  return window.matchMedia(`(min-width: ${TABLET_MIN}px)`).matches;
}

export function notTablet() {
  return window.matchMedia(`(max-width: ${MOBILE_MAX}px), (min-width: ${DESKTOP_MIN}px)`).matches;
}

export function notDesktop() {
  return window.matchMedia(`(max-width: ${TABLET_MAX}px)`).matches;
}

export function notLargeDesktop() {
  return window.matchMedia(`(max-width: ${DESKTOP_MAX}px)`).matches;
}



// WEBPACK FOOTER //
// ./src/lib/responsive.js